import { reactive } from 'vue'

const TOKEN_KEY = 'banane_token'
const REFRESH_KEY = 'banane_refresh'
const USER_KEY = 'banane_user'

function loadUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY)) || null
  } catch {
    return null
  }
}

// Reactive auth state shared across the app
export const authState = reactive({
  token: localStorage.getItem(TOKEN_KEY) || null,
  user: loadUser(),
})

export function getToken() {
  return authState.token
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY)
}

export function isAuthenticated() {
  return !!authState.token
}

export function setAuth({ token, refreshToken, user }) {
  authState.token = token
  if (user !== undefined) authState.user = user
  localStorage.setItem(TOKEN_KEY, token)
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken)
  if (user !== undefined) localStorage.setItem(USER_KEY, JSON.stringify(user))
}

// Update just the access token (after a refresh) without touching the user.
export function setToken(token) {
  authState.token = token
  localStorage.setItem(TOKEN_KEY, token)
}

// Refresh the stored user (e.g. to pick up newly-exposed fields like isStaff
// for a session that logged in before the schema exposed them).
export function setUser(user) {
  authState.user = user
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user))
  else localStorage.removeItem(USER_KEY)
}

export function logout() {
  authState.token = null
  authState.user = null
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(REFRESH_KEY)
  localStorage.removeItem(USER_KEY)
}
